<div>app-root works!</div>